import SearchInput
from "../shared/SearchInput";

import Button
from "../shared/Button";

import {
    RefreshCcw,
    Plus,
    Filter
} from "lucide-react";

import {
    LEAD_STATUSES
} from "../../constants/statuses";

import {
    LOAN_TYPES
} from "../../constants/loanTypes";
import EditorDropDownCard from "../../../UI/EditorDropDownCard";

export default function LeadToolbar({

    filters,

    onFiltersChange,

    onRefresh,

    onCreateLead

}){

    function update(key,value){

        onFiltersChange({

            ...filters,

            page:1,

            [key]:value

        });

    }

    return(

        <div className="crm-toolbar">

            <div className="crm-toolbar-left">

                <SearchInput

                    placeholder="Search leads..."

                    value={filters.q}

                    onChange={value=>

                        update(

                            "q",

                            value

                        )

                    }

                />

                <div className="">

                   

                   <EditorDropDownCard

    width="170px"

    hasDropDown

    activeCard={false}

    icon={Filter}

    onClickPopup={()=>{}}

    title={
        LEAD_STATUSES.find(
            item=>
                item.value===filters.status
        )?.label || "All Status"
    }

    dropDownObjectI={[

        {
            id:0,
            name:"All Status",
            value:""
        },

        ...LEAD_STATUSES.map(
            (item,index)=>({

                id:index+1,

                name:item.label,

                value:item.value

            })
        )

    ]}

    onClickBackObject={item=>

        update(

            "status",

            item.value

        )

    }

/>

                </div>

                <div className="">

                   <EditorDropDownCard

    width="170px"

    hasDropDown

    activeCard={false}

    icon={0}

    onClickPopup={()=>{}}

    title={
        LOAN_TYPES.find(
            item=>
                item.value===filters.loan_type
        )?.label || "Loan Type"
    }

    dropDownObjectI={[

        {
            id:0,
            name:"All Loan Types",
            value:""
        },

        ...LOAN_TYPES.map(
            (item,index)=>({

                id:index+1,

                name:item.label,

                value:item.value

            })
        )

    ]}

    onClickBackObject={item=>

        update(

            "loan_type",

            item.value

        )

    }

/>

                </div>

            </div>

            <div className="crm-toolbar-right">

                <Button

                    variant="secondary"

                    icon={<RefreshCcw size={18}/>}

                    onClick={onRefresh}

                >

                    Refresh

                </Button>

                <Button

                    icon={<Plus size={18}/>}

                    onClick={onCreateLead}

                >

                    New Lead

                </Button>

            </div>

<style>{`

.crm-toolbar{

    display:flex;

    justify-content:space-between;

    align-items:center;

    gap:20px;

    margin-bottom:24px;

    flex-wrap:wrap;

}

.crm-toolbar-left{

    display:flex;

    align-items:center;

    gap:14px;

    flex:1;

    flex-wrap:wrap;

}

.crm-toolbar-right{

    display:flex;

    align-items:center;

    gap:12px;

}

.toolbar-filter{

    display:flex;

    align-items:center;

    gap:8px;

    height:46px;

    padding:0 14px;

    border:1px solid #D7DCE3;

    border-radius:12px;

    background:#FFFFFF;

    transition:.2s;

}

.toolbar-filter:hover{

    border-color:#2563EB;

}

.toolbar-filter svg{

    color:#64748B;

    flex-shrink:0;

}

.toolbar-filter select{

    border:none;

    background:transparent;

    outline:none;

    font-size:14px;

    min-width:160px;

    cursor:pointer;

}

@media(max-width:768px){

.crm-toolbar{

    align-items:stretch;

}

.crm-toolbar-left{

    width:100%;

}

.crm-toolbar-right{

    width:100%;

    justify-content:flex-end;

}

.toolbar-filter{

    flex:1;

    min-width:170px;

}

}

`}</style>

        </div>

    );

}